/** Положительный nodeId диска; иначе null. */
export function parseMediaNodeId(raw: unknown): number | null {
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.trunc(parsed);
}
